import { FaTimes } from "react-icons/fa";

const CasinoIframeModal = ({ url, onClose }) => {
    if (!url) return null;

    return (
        <div className="casino-iframe-overlay">
            <div className="casino-iframe-container"
            // style={{paddingTop:'100px'}}
            >
                <div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px', background: 'linear-gradient(-180deg, #005641, #005641 82%)' }}>
                    <img src="/logo.png" width={70}
                        onClick={onClose} />
                    <button className="casino-close-btn" style={{ position: 'static' }} onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <iframe
                    src={url}
                    title="Casino Game"
                    frameBorder="0"
                    allowFullScreen
                />
            </div>
        </div>
    );
};

export default CasinoIframeModal;
